import React from 'react';

import { useIntl } from 'react-intl';

import { useAuthContext } from 'state/auth';

import { FriesSvg as UnauthenticatedEmptyStateImage } from '../../../../../components/svgs/fries';

import {
  EmptyStateWrapper,
  HeaderText,
  ImageWrapper,
  StyledActionButtonLink,
  SubText,
} from './styled';

const LoggedOutEmptyState = () => {
  const { formatMessage } = useIntl();
  const { openSignInModal } = useAuthContext();

  const onPress = () => {
    openSignInModal();
  };

  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <UnauthenticatedEmptyStateImage />
      </ImageWrapper>
      <HeaderText>{formatMessage({ id: 'unauthenticatedRecentItemsHeader' })}</HeaderText>
      <SubText>{formatMessage({ id: 'unauthenticatedRecentItemsSubtext' })}</SubText>
      <StyledActionButtonLink onPress={onPress}>
        {formatMessage({ id: 'logIn' })}
      </StyledActionButtonLink>
    </EmptyStateWrapper>
  );
};

export default LoggedOutEmptyState;
